var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-root"},[_c('p',{staticClass:"T_medium-heading"},[_vm._v(" "+_vm._s(_vm.$t('Logout.heading'))+" ")]),_c('div',[_c('ds-button',{attrs:{"size":"small","to":{ name: 'Login' }}},[_vm._v(" OK ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }